module.exports = {"athlete":"I am an individual that would like to receive nutrition coaching","parentGuardian":"I am a parent or guardian that would like to provide consent for my child to receive nutrition coaching","coach":"I am a coach or team administrator that will be inviting my team or organization to receive nutrition coaching"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/formSchemas/roleCopy.json
// module id = /Arp
// module chunks = 2